import './GetStarted.css';

const GetStarted = () => {
  return (
    <section className='getstarted container'>
      <div className='getstarted-overlay'></div>
      <div className='getstarted-content-wrapper'>
        <h2 className='getstarted-header'>¿Listo para integrar <span className="lancaster-color">Lancaster</span>?</h2>
        <p className='getstarted-paragraph'>Simplifica tus procesos.</p>
        <a
          href="https://wa.me/528112557887?text=Hola,%20quiero%20saber%20más%20sobre%20Lancaster"
          className='letstalk-button'
          alt='Contáctanos por Whatsapp'
        >
          Contáctame por Whatsapp
        </a>
      </div>
    </section>
  );
};

export default GetStarted;
